<script setup lang="ts">
/**
 * Change of Registered Office Address (B32105) — Directors' Resolutions in Writing.
 *   원본: Directors' Resolution (Change of Registered Office Address).docx
 *   토큰: company_name / company_registration_no / old_office_address(변경 전 = 현재 등록사무소) / new_office_address / dated / [[Signers]](이사 전원 → dr_Signers)
 *   dated 는 화면에서 날짜 입력이 되도록 resolution_date 로 받고, 문서 생성 시 dated 로 넘긴다.
 */
import CddVarField from '../final-dividends/cdd/CddVarField.vue';
import AgmSigners from '../final-dividends/cdd/AgmSigners.vue';
import '../final-dividends/docs/agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="doc-title">DIRECTORS&rsquo; RESOLUTIONS IN WRITING</div>
    <div class="doc-sub">PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div class="sec-title">CHANGE IN THE ADDRESS OF REGISTERED OFFICE</div>
    <!-- 긴 주소 칩이 통째로 줄바꿈되면 양쪽 정렬이 앞 줄 단어 간격을 벌린다 → 이 문단은 왼쪽 정렬 -->
    <p class="doc-p" style="text-align: left">
      RESOLVED THAT the Registered Office Address of the Company be changed from
      <CddVarField field-key="old_office_address" label="Current Registered Office Address" /> to
      <CddVarField field-key="new_office_address" label="New Registered Office Address" /> with immediate effect.
    </p>

    <div class="sec-title">LODGEMENT OF RETURNS</div>
    <p class="doc-p">
      RESOLVED THAT the Company Secretaries (or their authorised representatives) be and are hereby authorised and
      instructed to lodge the requisite statutory return(s) relating thereto with the Accounting and Corporate
      Regulatory Authority for and on behalf of the Company.
    </p>

    <p class="doc-p">Dated: <CddVarField field-key="resolution_date" label="Dated" /></p>

    <div class="sign-block">
      <AgmSigners var-key="dr_Signers" board-label="Director" />
    </div>
  </div>
</template>
